export function useMoneyFormatter(currency = 'USD') {
  const locale = usePage().props.user?.preferred_locale || 'en-US';
  const normalizedLocale = locale.replace('_', '-');

  return new Intl.NumberFormat(normalizedLocale, {
    style: 'currency',
    currency,
  });
}
